import React, {useMemo} from 'react';
import Container from '../../components/Container';
import GameBlock from "../../components/GameBlock";
import InnerPage from "../../components/InnerPage";
import ErrorPage from "../404/Error";
import BG from './assets/bg_games.webp';
import { useGames, useGamesContent } from "../../api/api";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import styles from './games.module.scss';
import Preloader from "../../components/Preloader";
import Page from "../../components/Page";

const Games = () => {
  const [t, i18n] = useTranslation("global");
  const lang = useMemo(() => i18n.language.slice(0, 2), [i18n.language]);
  const { gamesData, isGamesLoading, gamesError } = useGames(lang);
  const { gamesContent, isGamesContentLoading, gamesContentError } = useGamesContent(lang);

  const hasErrors = gamesError || gamesContentError;

  if (hasErrors) {
    return <ErrorPage />;
  }

  const dataLoaded = !isGamesLoading && !isGamesContentLoading;

  if (!dataLoaded) {
    return <Preloader />;
  }

  // Безопасное извлечение данных
  const { data } = gamesData || null;
  const content = gamesContent?.data; // Получаем данные игр, убедившись, что gamesContent существует

  return (
    <Page>
      <Helmet>
        <title>RedBark Studio | {t("pages.games")}</title>
      </Helmet>
      <InnerPage className={styles.wrapper} background={BG}>
        <Container className={styles.page}>
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className='text-pink'>{content?.title}</h2> {/* Безопасный доступ к title */}
              {content?.description && (
                <div className="text-large">
                  <p>{content.description}</p>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className={styles.games}>
              {data ? data.map((game) => (
                <GameBlock
                  key={game.id}
                  className={styles.gameBlock}
                  data={game}
                />
              )): null}
            </div>
          </div>
        </Container>
      </InnerPage>
    </Page>
  );
};

export default Games;